import strings from '../../../Localization/Localization';

let name = {
  fieldKey: "name",
  type: "text",
  label: strings.form.ticketType.name.label,
  showOnDisabled: () => false,
  validators: []
}

export const form = {
  formKey: "ticketTypeSearch",
  fields: [
    name
  ]
}
